import { Component, type ReactNode } from "react";

// Filet de sécurité : une exception pendant le rendu ne doit jamais laisser une page
// blanche. React démonte tout l'arbre en cas d'erreur non rattrapée ; ici seul le bloc
// fautif est remplacé par `fallback`, le reste de la page reste affiché.
// (Les erreurs des gestionnaires d'événements et du code asynchrone ne passent pas par
// là : elles ne cassent pas le rendu et sont gérées à leur niveau.)

type Props = { children: ReactNode; fallback: (reset: () => void) => ReactNode };
type State = { failed: boolean };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error("[ErrorBoundary]", error);
  }

  render() {
    return this.state.failed ? this.props.fallback(() => this.setState({ failed: false })) : this.props.children;
  }
}
